import axios from 'axios';
import store from '../store/index.js'
import myrouter from '../router/index.js'
axios.defaults.timeout = 60000;
//axios.defaults.baseURL ="http://yuyue.nbcmjk.com:5010"; //本地
axios.defaults.baseURL ="https://yuyue.nbcmjk.com:5050";//远程生产
// axios.defaults.headers.Authorization = store.state.token;

axios.interceptors.request.use(
	config => {
		config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		// alert(JSON.stringify(config.data))
		if (config.method == 'post') {
			config.headers = {
				'Content-Type':'application/json;charset=utf-8'
			};
			//config.data = JSON.stringify(config.data)
		};
		if (store.state.token) {
			config.headers.Authorization = "Bearer " + store.state.token
		}
		//alert(JSON.stringify(config.headers).substring(30));

		return config;
	},
	err => {
		return Promise.reject(err);
	}
);
//http reponse响应拦截器
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					store.commit('$_removeStorage');
					localStorage.removeItem('token');
					myrouter.push('loginbook');
			}
			
		}
	});
export default axios;

axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8'; //'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

var instance = axios.create({
	headers: {
		'content-type': 'multipart/form-data'
	}
});

//http request 拦截器
// axios.interceptors.request.use((config) => {
//   if(config.method  === 'post'){
//     config.data = JSON.stringify(config.data);
//   }
//   return config;
// },(error) =>{
//   return Promise.reject(error);
// });

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
// export function get(url, params = {}) {
// 	return new Promise((resolve, reject) => {
// 		axios.get(url, {
// 				params: params
// 			})
// 			.then(response => {
// 				resolve(response.data);
// 			})
// 			.catch(err => {
// 				reject(err)
// 			})
// 	})
// }
// export function getfile(url, params = {}) {
// 	return new Promise((resolve, reject) => {
// 		axios({
// 			methods: 'get',
// 			url: url,
// 			headers: {
// 				//'Content-Type': 'application/x-www-form-urlencoded',
// 				 'content-type': 'application/octet-stream',
// 				'Authorization': "Bearer " + store.state.token
// 			},
// 			params:params
// 		})
// 				.then(response => {
// 					resolve(response.data);
// 				})
// 				.catch(err => {
// 					reject(err)
// 				})
// 	})
// }
const baseURL=axios.defaults.baseURL;
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function post(url, data = {}) {
// 	return new Promise((resolve, reject) => {
// 		axios.post(url, data)
// 			.then(response => {
// 				resolve(response.data);
// 			}, err => {
// 				reject(err)
// 			})
// 	})
// }

/**
 * 封装post请求 FormData方式
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function postform(url, data = {}) {
// 	return new Promise((resolve, reject) => {
// 		instance.post(url, data)
// 			.then(response => {
// 				resolve(response.data);
// 			}, err => {
// 				reject(err)
// 			})
// 	})
// }
